// Centralized imagery map — one import per URL, one source of truth.
import heroAbstract from "@/assets/media/hero-new.jpg.asset.json";
import heroAbstract800 from "@/assets/media/hero-new-800.jpg.asset.json";
import heroAbstract1280 from "@/assets/media/hero-new-1280.jpg.asset.json";
import heroAbstract800Webp from "@/assets/media/hero-new-800.webp.asset.json";
import heroAbstract1280Webp from "@/assets/media/hero-new-1280.webp.asset.json";
import heroAbstract480Avif from "@/assets/media/hero-new-480.avif.asset.json";
import heroAbstract480Webp from "@/assets/media/hero-new-480.webp.asset.json";
import heroAbstract800Avif from "@/assets/media/hero-new-800.avif.asset.json";
import heroAbstract1280Avif from "@/assets/media/hero-new-1280.avif.asset.json";




export const MEDIA = {
  heroAbstract: heroAbstract.url,
  heroAbstract800: heroAbstract800.url,
  heroAbstract1280: heroAbstract1280.url,
  heroAbstract480Avif: heroAbstract480Avif.url,
  heroAbstract480Webp: heroAbstract480Webp.url,
  heroAbstract800Webp: heroAbstract800Webp.url,
  heroAbstract1280Webp: heroAbstract1280Webp.url,
  heroAbstract800Avif: heroAbstract800Avif.url,
  heroAbstract1280Avif: heroAbstract1280Avif.url,
};

// AVIF/WebP variant keys — map slug → base filename in MEDIA_VARIANTS.
export function serviceVariantKey(slug: string): string {
  return `svc-${slug}`;
}
export function industryVariantKey(slug: string): string {
  return `ind-${slug}`;
}
export function locationVariantKey(slug: string): string {
  return slug === "austin" ? "austin" : `loc-${slug}`;
}

